export const CATEGORIES_VET = {
    Animal: [
        {
            name: 'Canine',
            subcategories: [],
        },
        {
            name: 'Feline',
            subcategories: [],
        },
        {
            name: 'Equine',
            subcategories: [],
        },
        {
            name: 'Farm Animals',
            subcategories: ['Alpaca', 'Bovine', 'Chicken', 'Donkey', 'Duck', 'Goat', 'Sheep'],
        },
        {
            name: 'Small Animals',
            subcategories: ['Chinchilla', 'Guinea pig', 'Hamster', 'Rabbit', 'Rat', 'Mouse', 'Ferret'],
        },
        {
            name: 'Exotic Animals',
            subcategories: [
                {
                    name: 'Amphibians',
                    subcategories: ['Axolotl', 'Frog'],
                },
                {
                    name: 'Reptiles',
                    subcategories: ['Snake', 'Turtle', 'Lizard'],
                },
            ],
        },
    ],
    Behaviour: [],
    Dentistry: [],
    Dermatology: [],
    Diagrams: [],
    '3D Models': [],
    Emergency: [],
    'General anatomy': [],
    'General principles': [],
    'Internal medicine': [],
    Neurology: [],
    Ophthalmology: [],
    Orthopaedics: [],
    Parasites: [],
    Reproduction: [],
    Surgery: [],
};
